import Badge from './Badge'
import {Colors} from '../constants/colors'
import {
  CustomerState,
  EmployerState,
  PayoutCreditFacilityState,
} from '../redux/types'

type State = CustomerState | EmployerState | PayoutCreditFacilityState

interface Props {
  state?: State
}

const StateBadge = ({state}: Props) => {
  if (!state) {
    return null
  }

  const getBadgeColors = () => {
    switch (state) {
      case 'active':
        return {backgroundColor: Colors.euro_600, textColor: Colors.white}
      case 'locked':
        return {backgroundColor: Colors.yen_500, textColor: Colors.darkDark}
      case 'terminated':
        return {backgroundColor: Colors.rubel_600, textColor: Colors.white}
    }
  }

  const formatState = () => state.charAt(0).toUpperCase() + state.slice(1)
  const badgeColors = getBadgeColors()

  return (
    <Badge
      text={formatState()}
      backgroundColor={badgeColors.backgroundColor}
      textColor={badgeColors.textColor}
    />
  )
}

export default StateBadge
